import { Directive, HostBinding, Input } from '@angular/core';

import { A11yBooleanInput } from '../interfaces/a11y.interfaces';
import { toBoolean } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yHidden]'
})
export class A11yHiddenDirective {
  @Input('khA11yHidden') public hidden: A11yBooleanInput = true;

  @HostBinding('attr.aria-hidden')
  public get ariaHidden(): 'true' | null {
    return this.isHidden ? 'true' : null;
  }

  private get isHidden(): boolean {
    return toBoolean(this.hidden, true);
  }
}
